export default {
      id: "uspCard-saveOnTax-usage",
      viewBox: "0 0 200 60",
      url: __webpack_public_path__ + "sprite.svg#uspCard-saveOnTax",
      toString: function () {
        return this.url;
      }
    }